export const getProductNameFromServiceId = (serviceTypeId: number) => {
  const names = {
    1: 'móveis',
    2: '',
    3: 'eletrodomésticos'
  } as {
    [key: number]: string;
  }

  return names[serviceTypeId] ? `${names[serviceTypeId]}` : 'produtos';
}
